// import $ from 'expose-loader?exposes=$,jQuery!jquery';

// import axios from 'axios';
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

import Config from './utilities/Config.js';
import Breakpoint from './utilities/Breakpoint.js';

import ImagesLoaded from './modules/ImagesLoaded.js';
import Click from './modules/Click.js';
import ScrollTo from './modules/ScrollTo.js';
import Obfuscate from './modules/Obfuscate.js';
import ItemList from './modules/ItemList.js';
import FixedHeader from './modules/FixedHeader.js';
import LinkTransition from './modules/LinkTransition.js';
import Counter from './modules/Counter.js';
import Gallery from './modules/Gallery.js';
import Map from './modules/Map.js';
import RequestForm from './modules/RequestForm.js';
import SwiperSlider from './modules/SwiperSlider.js';

Config();
Breakpoint();

const modules = {
  imagesLoaded: ImagesLoaded(),
  click: Click(),
  scrollTo: ScrollTo(),
  obfuscate: Obfuscate(),
  itemList: ItemList(),
  fixedHeader: FixedHeader(),
  linkTransition: LinkTransition(),
  counter: Counter(),
  gallery: Gallery(),
  map: Map(),
  requestForm: RequestForm(),
  swiperSlider: SwiperSlider(),
};
Object.values(modules).forEach((module) => {
  module.init();
});
